import React, { Component } from "react";
import {
    Panel,
    Modal,
    Button,
    OverlayTrigger,
    Tooltip,
    ButtonGroup
}                           from "react-bootstrap";
  import {
    ToastContainer,
    toast
}                           from "react-toastify";
import                           "react-toastify/dist/ReactToastify.css";

import CrudComponent        from "./../zynappse-crud";
import CardSchema 
                            from "./CardSchema.js";
import CardNewSchema 
                            from "./CardNewSchema.js";
import FormContainer        from "./FormContainer";
import saveTrail            from '../../utils/saveTrail';

import {
    IS_VALID
}                           from "utils";

class CardImages extends Component {
    constructor (props) {
        super(props);

        this.refreshTableReference;
        
        this.refreshTable = this.refreshTable.bind(this);
        this.renderModalButton = this.renderModalButton.bind(this);
        this.saveData = this.saveData.bind(this);
        this.deleteData = this.deleteData.bind(this);
        this.accessible = this.accessible.bind(this);
    }

    refreshTable () {
        if (IS_VALID(this.refreshTableReference) && typeof this.refreshTableReference === 'function') {
            this.refreshTableReference();
        }
    }

    renderModalButton () {
        let {
            CardImages,
            actions
        } = this.props;

        let {
            formType,
            isLoadingAction
        } = CardImages;

        let buttons = [];

        let button = (name, callback) => (
            <Button
                bsStyle="primary"
                onClick={() => callback()}
                disabled={isLoadingAction}
            >
                {isLoadingAction ? <span><i className="fa fa-spinner fa-spin" style={{ color: "white" }}></i>&nbsp;</span> : ''}
                {name}
            </Button>
        );

        let buttonClose = (
            <Button
                disabled={isLoadingAction}
                onClick={() => {
                    if (!isLoadingAction) {
                        actions.setValue({
                            showModal: false
                        });
                    }
                }}
            >
                CLOSE
            </Button>
        );

        switch (formType.toUpperCase()) {
            case "CREATE":
                buttons.push(
                    button("CREATE", this.saveData),
                    buttonClose
                );
                break;
            case "UPDATE":
                buttons.push(
                    button("UPDATE", this.saveData),
                    buttonClose
                );
                break;
            case "DUPLICATE":
                buttons.push(
                    button("DUPLICATE", this.saveData),
                    buttonClose
                );
                break;
            case "DELETE":
                buttons.push(
                    button("DELETE", this.deleteData),
                    buttonClose
                );
                break;
            default:
                break;
        }
        return buttons;
    }

    saveData () {
        let {
            CardImages,
            actions
        } = this.props;

        let {
            selectedData,
            formType,

            cardType,
            cardName,
            cardImg,

            isNewCard
        } = CardImages;

        if (
            !IS_VALID(cardName) ||
            !IS_VALID(cardName.trim())
        ) {
            toast.error("Card Name is required.");
        } else if (
            !IS_VALID(cardType) ||
            !IS_VALID(cardType.trim())
        ) {
            toast.error("Card Type is required.");
        } else {
            actions.setValue({
                isLoadingAction: true
            });

            let card = new Parse.Object("Card" + (isNewCard ? 'New' : ''));

            if (
                formType === "UPDATE" &&
                IS_VALID(selectedData)
            ) {
                card = selectedData;
            }

            card
            .set("cardName", cardName.trim())
            .set("cardType", cardType.trim());

            new Promise((resolve, reject) => {
                if (
                    cardImg &&
                    cardImg.preview
                ) {
                    let fileNameArray = cardImg.name.split(/\./g),
                    extension = fileNameArray[fileNameArray.length -1];

                    resolve(
                        new Parse.File('card_image.'+extension, cardImg).save() // 
                    );
                } else if (
                    cardImg &&
                    cardImg.url &&
                    cardImg.name
                ) {
                    resolve(
                        Parse.File.fromJSON({
                            name: cardImg.name,
                            url: cardImg.url,
                            __type: "File"
                        })
                    );
                } else {
                    resolve(false);
                }
            })
            .then((cardImg) => {
                if (cardImg) {
                    card.set("cardImg", cardImg);
                }

                return card.save();
            })
            .then((data) => {
                 actions.setValue({
                    isLoadingAction: false,
                    showModal: false
                });

                this.refreshTable();

                saveTrail(
                    formType.toUpperCase(),
                    {
                        id: data.id,
                        cardName: cardName.trim(),
                        cardType: cardType.trim()
                    }    
                );
            })
            .catch((err) => {
                console.log("saveData error");
                console.log(err);

                actions.setValue({
                    isLoadingAction: false,
                    showModal: false
                });

                this.refreshTable();
            });
        }
    }

    deleteData () {
        let {
            CardImages,
            actions
        } = this.props;

        let {
            selectedData
        } = CardImages;

        actions.setValue({
            isLoadingAction: true
        });

        selectedData.set("isDeleted", true);

        selectedData.save()
        .then((data) => {
            actions.setValue({
                isLoadingAction: false,
                showModal: false
            });

            this.refreshTable();

            saveTrail(
                "DELETE",
                {
                    id: selectedData.id,
                    cardName: selectedData.get("cardName"),
                    cardType: selectedData.get("cardType")
                }
            );
        })
        .catch((err) => {
            console.log("deleteData error");
            console.log(err);

            actions.setValue({
                isLoadingAction: false,
                showModal: false
            });

            this.refreshTable();
        });
    }

    accessible (actionType) {
		let {
			access
		} = this.props.accessjson;

		if (access.length !== 0) {
			var currentPath = window.location.pathname,
					index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
					actions = [];

			if (access[index]) {
				actions = access[index].actions
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
	      return 'none';
	    }
		} else {
			return 'none';
		}
	}

    render () {
        let {
            CardImages,
            accessjson,
            actions
          } = this.props;
      
          let {
            showModal,
            isLoadingAction,

            selectedData,
            formType,
            formTitle,

            cardType,
            cardName,
            cardImg,

            isNewCard
        } = CardImages;

        let customUpdate = (obj, formType = "UPDATE") => {
            let stateToUpdate = {
                showModal: true,
                formType: formType,
                formTitle: formType,
                formId: obj.id,
                selectedData: obj
            };

            if (IS_VALID(obj.get("cardName"))) {
                stateToUpdate.cardName = obj.get("cardName");
            }

            if (IS_VALID(obj.get("cardType"))) {
                stateToUpdate.cardType = obj.get("cardType");
            }

            if (IS_VALID(obj.get("cardImg"))) {
                stateToUpdate.cardImg = { url: obj.get("cardImg").url(), name: obj.get("cardImg").name() };
            }

            actions.setValue(stateToUpdate);
        }

        let crudProps = {
            schema: CardSchema,
            access: accessjson.access,
            moduleQuery: [
                { method: "ascending", column: "cardName" }
            ],
            refreshTable: (refreshTable) => {
                this.refreshTableReference = refreshTable;
            },
            customCreate: () => {
                actions.setValue({
                    showModal: true,
                    formType: "CREATE",
                    formTitle: "CREATE"
                });
            },
            customUpdate: customUpdate,
            customDelete: (obj) => {
                let stateToUpdate = {
                    showModal: true,
                    formType: "DELETE",
                    formTitle: "DELETE",
                    formId: obj.id,
                    selectedData: obj
                };

                actions.setValue(stateToUpdate);
            },
            customAction: ({ object, buttonView, buttonUpdate, buttonDelete }) => {
                return ([
                        buttonView,
                        buttonUpdate,
                        this.accessible("DUPLICATE") === "" ? (
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>Duplicate</Tooltip>}
                            >
                            <a
                                className="fa fa-copy fa-lg"
                                href="javascript:void(0)"
                                onClick={() => customUpdate(object, "DUPLICATE")}
                            />
                            </OverlayTrigger>
                        ) : (
                        ""
                        ),
                        buttonDelete
                    ]
                );
            }
        };

        let crudPropsNew = {
            ...crudProps,
            schema: CardNewSchema
        }

        let formContainerProps = {
            actions,

            isLoadingAction,

            formType,
            selectedData,

            cardType,
            cardName,
            cardImg
        };

        return (
            <div>
                <Panel>
                    <Panel.Heading style={{
                        backgroundColor: '#D1282F',
                        color: 'white'
                    }}>
                        <h4 style={{ display: "inline-block" }}>Card Images</h4>
                        <div
                        style={{ float: "right" }}>
                            <ButtonGroup>
                                <Button
                                    bsStyle={!isNewCard ? 'info' : 'default'}
                                    onClick={() => {
                                        actions.setValue({
                                            isNewCard: false
                                        })
                                    }}
                                >OLD</Button>
                                <Button
                                    bsStyle={isNewCard ? 'info' : 'default'}
                                    onClick={() => {
                                        actions.setValue({
                                            isNewCard: true
                                        })
                                    }}
                                >NEW</Button>
                            </ButtonGroup>
                        </div>
                    </Panel.Heading>
                    <Panel.Body>
                        {isNewCard ? <CrudComponent key='new' id='new' {...crudPropsNew}/> 
                        :
                        <CrudComponent key='old' id='old' {...crudProps}/>}
                    </Panel.Body>
                </Panel>
                <Modal
                    bsSize={null}
                    show={showModal}
                    onHide={() => {
                        if (!isLoadingAction) {
                            actions.setValue({
                                showModal: false
                            });
                        }
                    }}
                >
                     <Modal.Header closeButton>
                        <Modal.Title>{formTitle.toUpperCase()}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FormContainer {...formContainerProps}/>
                    </Modal.Body>
                    <Modal.Footer>
                        {this.renderModalButton()}
                    </Modal.Footer>
                </Modal>
                <ToastContainer />
            </div>
        );
    }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';
import {
    SET_CARD_IMAGES
}                           from "actions/const";

function mapStateToProps(state) {
	var {
		accessjson,
        CardImages
	} = state;
	return {
		accessjson,
        CardImages
	};
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setValue: (keyValueObj, actioType = SET_CARD_IMAGES) => generics.setValue(actioType, keyValueObj)
  };

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CardImages);


// WEBPACK FOOTER //
// ./components/CardImages/index.js